<template>
	<div class="notification-management">
		<el-card>
			<div slot="header" class="clearfix">
				<span>通知管理</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="showAddDialog">
					添加通知
				</el-button>
			</div>

			<el-row :gutter="20" class="filter-row">
				<el-col :span="8">
					<el-input v-model="filter.title" placeholder="按标题搜索" clearable @clear="fetchNotifications"
						@keyup.enter.native="fetchNotifications">
						<el-button slot="append" icon="el-icon-search" @click="fetchNotifications"></el-button>
					</el-input>
				</el-col>
				<el-col :span="8">
					<el-select v-model="filter.status" placeholder="按状态筛选" clearable @change="fetchNotifications">
						<el-option label="全部" value="all"></el-option>
						<el-option label="已发布" value="published"></el-option>
						<el-option label="未发布" value="unpublished"></el-option>
					</el-select>
				</el-col>
			</el-row>

			<el-table :data="notificationList" border style="width: 100%">
				<el-table-column prop="id" label="ID" width="80"></el-table-column>
				<el-table-column prop="title" label="标题"></el-table-column>
				<el-table-column prop="creator_name" label="创建人" width="120"></el-table-column>
				<el-table-column label="发布时间" width="180">
					<template slot-scope="scope">
						{{ scope.row.publish_time | formatDateTime }}
					</template>
				</el-table-column>
				<el-table-column label="过期时间" width="180">
					<template slot-scope="scope">
						{{ scope.row.expire_time | formatDateTime }}
					</template>
				</el-table-column>
				<el-table-column label="状态" width="100">
					<template slot-scope="scope">
						<el-tag :type="scope.row.is_published  == 1 ? 'success' : 'info'">
							{{ scope.row.is_published == 1 ? '已发布' : '未发布' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="220">
					<template slot-scope="scope">
						<el-button v-if="!scope.row.is_published" size="mini" type="success"
							@click="handlePublish(scope.row.id)">发布</el-button>
						<el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
			</el-pagination>
		</el-card>

		<!-- 添加/编辑对话框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%" @close="resetForm"
			:close-on-click-modal="false">
			<el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
				<el-form-item label="通知标题" prop="title">
					<el-input v-model="form.title"></el-input>
				</el-form-item>
				<el-form-item label="通知内容" prop="content">
					<el-input type="textarea" :rows="5" v-model="form.content"></el-input>
				</el-form-item>
				<el-form-item label="发布时间">
					<el-date-picker v-model="form.publish_time" type="datetime" placeholder="选择发布时间"
						value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
				</el-form-item>
				<el-form-item label="过期时间">
					<el-date-picker v-model="form.expire_time" type="datetime" placeholder="选择过期时间(可选)"
						value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
				</el-form-item>
				<el-form-item label="发布状态">
					<el-switch v-model="form.is_published" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitForm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		apiBaseUrl
	} from '@/config';

	export default {
		filters: {
			formatDateTime(value) {
				if (!value) return '-';
				const date = new Date(value);
				return date.toLocaleString();
			}
		},
		data() {
			return {
				notificationList: [],
				filter: {
					title: '',
					status: 'all'
				},
				pagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
				dialogVisible: false,
				dialogTitle: '添加通知',
				form: {
					id: '',
					title: '',
					content: '',
					publish_time: new Date(),
					expire_time: '',
					is_published: 0
				},
				rules: {
					title: [{
							required: true,
							message: '请输入通知标题',
							trigger: 'blur'
						},
						{
							max: 100,
							message: '长度不能超过100个字符',
							trigger: 'blur'
						}
					],
					content: [{
						required: true,
						message: '请输入通知内容',
						trigger: 'blur'
					}]
				},
				isEdit: false
			};
		},
		created() {
			this.fetchNotifications();
		},
		methods: {
			async fetchNotifications() {
				try {
					const params = {
						action: 'list',
						page: this.pagination.currentPage,
						pageSize: this.pagination.pageSize
					};

					if (this.filter.title) {
						params.title = this.filter.title;
					}

					if (this.filter.status && this.filter.status !== 'all') {
						params.status = this.filter.status;
					}

					const response = await fetch(`${apiBaseUrl}/notifications.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(params),
					});

					const data = await response.json();

					if (data.success) {
						this.notificationList = data.data;
						this.pagination.total = parseInt(data.total);
					} else {
						throw new Error(data.message || '获取通知列表失败');
					}
				} catch (error) {
					this.$message.error(error.message);
					console.error('Error fetching notifications:', error);
				}
			},

			showAddDialog() {
				this.dialogTitle = '添加通知';
				this.isEdit = false;
				this.form = {
					id: '',
					title: '',
					content: '',
					publish_time: new Date(),
					expire_time: '',
					is_published: 0
				};
				this.dialogVisible = true;
			},

			handleEdit(row) {
				this.dialogTitle = '编辑通知';
				this.isEdit = true;
				this.form = {
					id: row.id,
					title: row.title,
					content: row.content,
					publish_time: row.publish_time,
					expire_time: row.expire_time || '',
					is_published: row.is_published
				};
				this.dialogVisible = true;
			},

			async submitForm() {
				try {
					const valid = await this.$refs.form.validate();
					if (!valid) return;

					const action = this.isEdit ? 'update' : 'add';
					const payload = {
						...this.form,
						action: action
					};

					// 转换日期格式
					if (payload.publish_time instanceof Date) {
						payload.publish_time = payload.publish_time.toISOString().replace('T', ' ').substring(0, 19);
					}

					if (payload.expire_time && payload.expire_time instanceof Date) {
						payload.expire_time = payload.expire_time.toISOString().replace('T', ' ').substring(0, 19);
					}

					const response = await fetch(`${apiBaseUrl}/notifications.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify(payload)
					});

					const data = await response.json();

					if (!data.success) {
						throw new Error(data.message || (this.isEdit ? '更新失败' : '添加失败'));
					}

					this.$message.success(this.isEdit ? '更新成功' : '添加成功');
					this.dialogVisible = false;
					this.fetchNotifications();
				} catch (error) {
					this.$message.error(error.message);
				}
			},

			async handlePublish(id) {
				try {
					await this.$confirm('确定要发布该通知吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					});

					const response = await fetch(`${apiBaseUrl}/notifications.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							id,
							action: "add"
						})
					});

					const data = await response.json();

					if (!data.success) {
						throw new Error(data.message || '发布失败');
					}

					this.$message.success('发布成功');
					this.fetchNotifications();
				} catch (error) {
					if (error !== 'cancel') {
						this.$message.error(error.message);
					}
				}
			},

			async handleDelete(id) {
				try {
					await this.$confirm('确定要删除该通知吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					});

					const response = await fetch(`${apiBaseUrl}/notifications.php?action=delete`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							id
						})
					});

					const data = await response.json();

					if (!data.success) {
						throw new Error(data.message || '删除失败');
					}

					this.$message.success('删除成功');
					this.fetchNotifications();
				} catch (error) {
					if (error !== 'cancel') {
						this.$message.error(error.message);
					}
				}
			},

			handleSizeChange(val) {
				this.pagination.pageSize = val;
				this.fetchNotifications();
			},

			handleCurrentChange(val) {
				this.pagination.currentPage = val;
				this.fetchNotifications();
			},

			resetForm() {
				this.$refs.form.resetFields();
			}
		}
	};
</script>

<style scoped>
	.notification-management {
		/* padding: 20px; */
	}

	.filter-row {
		margin-bottom: 20px;
	}
</style>